import { InjectionToken } from '@angular/core';
import {
    FloorPattern,
    GroutSettings,
    PlaneXYPosition,
    ProductExtended,
    ProductTileSize,
    TextureTransitionType,
} from '@floori/models';
import { Observable } from 'rxjs';
import { HotpointProductPair } from '../hotpoint-product-pair';
import { ProductTransform } from '../product-transform';
import { HashMap } from '@floori-web-components';

export const FLOORI_SCENE_PROVIDER = new InjectionToken('FLOORI_SCENE_PROVIDER');

export interface SceneProvider {
    scene$: Observable<number>;
    activeProduct$: Observable<ProductExtended | undefined | null>;
    activeProducts$: Observable<ProductExtended[]>;
    currentSettings$: Observable<ProductTransform>;
    selectedProducts$: Observable<ProductExtended[]>;
    lastRugPosition$: Observable<PlaneXYPosition | undefined>;
    hotpointProductMap$: Observable<Record<string, HotpointProductPair>>;
    currentVariantSku$: Observable<string | undefined>;
    visualizationUpdate$: Observable<boolean>;

    setScene(scene: number): void;

    setActiveProduct(
        product?: ProductExtended,
        updateVisualization?: boolean,
        additional?: boolean,
        search?: string,
    ): void;

    setInitialRugPosition(position?: PlaneXYPosition): void;

    setLastRugPosition(position?: PlaneXYPosition): void;

    clearProduct(product?: ProductExtended | null): void;

    updateHotpointsMap(selectionMap: HashMap<boolean>, updateVisualization?: boolean): void;

    updateRotation(angle: number): void;

    updateTransition(value: number, type: TextureTransitionType): void;

    updateSize(size: ProductTileSize): void;

    updatePatternAndGrout(pattern: FloorPattern, grout?: GroutSettings): void;

    updateSettings(): void;

    applySettings(settings: ProductTransform): void;

    resetSettings(): void;

    verifySettings(product: ProductExtended, forceUpdate?: boolean): void;

    visualizeSettings(settings: ProductTransform): void;

    resetVisualizationUpdate(scene?: number): void;

    sceneCleanUp(): void;
}
